import { setAttributesDOM } from '../utils.js';

export default function seoWidget() {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  function modifyTitle(data) {
    const { Title: text } = data.items[0];
    const h1 = `<h1 class="card-widget-title" aria-label="${text}">${text}</h1>`;
    $widgetHTML.find('span.card-widget-title').replaceWith(h1);
  }

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data, _owl, hasData) {
      const buttonwrap = $widgetHTML.find('.buttonwrap');
      const buttons = buttonwrap.find('a');
      if (hasData) {
        buttons.each((x, item) => {
          const $item = $(item);
          const url = $item.attr('href') || '';
          const label = $item.text().trim();
          setAttributesDOM($item, url, label);
          modifyTitle(data);
        });
        buttonwrap.find('a').addClass('button');
        buttonwrap.append(buttonwrap.find('.buyNowButton'));
      } else {
        $widgetHTML.parent().remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'LEARN MORE',
    },
    buyNowButton: {
      visible: true,
      text: 'Download Map',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
